import './App.css';
import './index.css';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import {BrowserRouter as Router,
    Route, Switch,Routes,
  Link } from "react-router-dom";
import Home from './Component/Home/Home';
import Listing from './Component/Listing/Listing';
import Login from './Component/Login/Login';
import Register from './Component/Register/Register';
import Productdetails from './Component/Productdetails/Productdetails';
import Dashboard from './Component/Dashboard/Dashboard';
import Profile from './Component/Dashboard/Profile';
import ChangedPassword from './Component/Dashboard/Changedpassword';
import ProtectedRoute from './Component/ProtectedRoute';
import Sellproduct from './Component/Dashboard/Sellproduct';
import Listproduct from './Component/Dashboard/Listproduct';
import Editproduct from './Component/Dashboard/Editproduct';
import Listwishlist from './Component/Dashboard/Listwishlist';
import Goldprice from './Component/Goldprice';
import Silverprice from './Component/Silverprice';
import Contact from './Component/Contact';
import ChatInbox from './Component/Dashboard/ChatInbox';
import TermsConditions from './Component/TermsConditions';
import PrivacyPolicy from './Component/PrivacyPolicy';
import AboutUs from './Component/AboutUs';
import FAQ from './Component/faq';

function App() {
  return (
    <div className="App">
      <Router>
        <Header/>
          <Switch>
              <Route exact path="/"><Home/></Route>
              <Route exact path="/listing"><Listing/></Route>
              <Route exact path="/details/:id"><Productdetails/></Route>
              <Route exact path="/login"><Login/></Route>
              <Route exact path="/register"><Register/></Route>
              <ProtectedRoute path="/dashboard" component={Dashboard} />
              <ProtectedRoute path="/profile" component={Profile} />
              <ProtectedRoute path="/changed-password" component={ChangedPassword} />
              <ProtectedRoute path="/sell-product" component={Sellproduct} />
              <ProtectedRoute path="/list-product" component={Listproduct} />
              <ProtectedRoute path="/edit-product/:id" component={Editproduct} />
              <ProtectedRoute path="/list-wishlist" component={Listwishlist} />
              <ProtectedRoute path="/inbox" component={ChatInbox} />
              <Route exact path="/gold-price"><Goldprice/></Route>
              <Route exact path="/silver-price"><Silverprice/></Route>
              <Route exact path="/contact"><Contact/></Route>
              <Route exact path="/terms-conditions"><TermsConditions/></Route>
              <Route exact path="/privacy-policy"><PrivacyPolicy/></Route>
              <Route exact path="/about-us"><AboutUs/></Route>
              <Route exact path="/faq"><FAQ/></Route>
          </Switch>
        <Footer/>
      </Router>
     </div>
     
  );
}

export default App;
